import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
export const CurrencyIconElement = ({ color, size = 10 }) => {
    const containerCss = useMemo(() => css `
      display: inline-block;
      width: ${size}px;
      max-width: ${size}px;
      height: ${size}px;
      max-height: ${size}px;
      margin-right: 3px;
      border-radius: 50%;
      border: 1px solid black;
      background-color: ${color};
      filter: drop-shadow(1px 1px 0 black);
    `, [color, size]);
    return _jsx("div", { css: containerCss });
};
